// Shared labels and tones for the knowledge base UI. Kept in one place so the
// table, filters, upload and edit dialogs stay consistent.

export const SOURCE_TYPES = [
  { value: 'product', label: 'Scheda prodotto' },
  { value: 'manual', label: 'Manuale' },
  { value: 'procedure', label: 'Procedura' },
  { value: 'article', label: 'Articolo' },
  { value: 'owner-content', label: 'Contenuto titolare' },
  { value: 'misc', label: 'Altro' }
];

export const SOURCE_LABEL = Object.fromEntries(SOURCE_TYPES.map((s) => [s.value, s.label]));

export const STATUS_TONE = {
  ready: 'success',
  indexing: 'info',
  pending: 'warning',
  failed: 'danger',
  archived: 'neutral'
};

export const STATUS_LABEL = {
  ready: 'Pronto',
  indexing: 'Indicizzazione',
  pending: 'In coda',
  failed: 'Errore',
  archived: 'Archiviato'
};

export const FILE_ACCEPT =
  '.pdf,.docx,.md,.markdown,.txt,.html,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,text/markdown,text/html';
